/* tslint:disable:max-line-length */

import {setSessionStorage} from '../util/Natutil'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {ADMINISTORATOR_MODE} from '../../../CodeMaster'
import {AdminUserLoginInfo} from '../../components/login/repository/AdminUserLoginInfo'
import {Nullable} from '../../../app/TypeHelpers'

export const AdminLoginInfoSessionStorageKey = {
    AUTHORITIES: 'AUTHORITIES',
    SELECTED_MODE: 'selectedMode',
    SELECTED_CONDOMINIUM_CD: 'selectedCondominiumCd',
    SELECTED_CONDOMINIUM_NAME: 'selectedCondominiumName',
    LOGIN_USER_CONDOMINIUM_CD: 'loginUserCondominiumCd',
    LOGIN_USER_CONDOMINIUM_NAME: 'loginUserCondominiumName',
    LOGIN_USER_CONDOMINIUM_GROUP_ID: 'loginUserCondominiumGroupId',
    LOGIN_USER_CONDOMINIUM_GROUP_NAME: 'loginUserCondominiumGroupName',
    LOGIN_USER_ADMIN_ID: 'loginUserAdminId',
    LOGIN_USER_FAMILY_NAME: 'loginUserAdminFamilyName',
    LOGIN_USER_FIRST_NAME: 'loginUserAdminFirstName',
    LOGIN_USER_ROLE_ID: 'loginUserRoleId',
    LOGIN_USER_ROLE_NAME: 'loginUserRoleName',
} as const
type AdminLoginInfoSessionStorageKey =
    typeof AdminLoginInfoSessionStorageKey[keyof typeof AdminLoginInfoSessionStorageKey];

export class NatAdminLoginInfoSessionStorageHelper {

    static getStringItemOrNull(key: AdminLoginInfoSessionStorageKey): Nullable<string> {
        return SessionStorageHelper.getStringItemOrNull(key)
    }

    static getNumberItemOrNull(key: AdminLoginInfoSessionStorageKey): Nullable<number> {
        return SessionStorageHelper.getNumberItemOrNull(key)
    }

    static setSessionStorage(adminLoginUserInfo: AdminUserLoginInfo): void {
        setSessionStorage(AdminLoginInfoSessionStorageKey.AUTHORITIES, JSON.stringify(adminLoginUserInfo.authority))
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_CD, adminLoginUserInfo.condominiumCd)
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_NAME,
            adminLoginUserInfo.condominiumName)
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID,
            adminLoginUserInfo.condominiumGroupId)
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_NAME,
            adminLoginUserInfo.condominiumGroupName)
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_ADMIN_ID, adminLoginUserInfo.adminId)
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_FAMILY_NAME, adminLoginUserInfo.familyName)
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_FIRST_NAME, adminLoginUserInfo.firstName)
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID, adminLoginUserInfo.role)
        setSessionStorage(AdminLoginInfoSessionStorageKey.LOGIN_USER_ROLE_NAME, adminLoginUserInfo.roleName)
        setSessionStorage(AdminLoginInfoSessionStorageKey.SELECTED_MODE, adminLoginUserInfo.mode)
        setSessionStorage(AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD, adminLoginUserInfo.condominiumCd)
        setSessionStorage(AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME, adminLoginUserInfo.condominiumName)
    }

    static setSessionStorageForAllMode(authority: string[] | null): void {
        SessionStorageHelper.setItem(AdminLoginInfoSessionStorageKey.SELECTED_MODE, ADMINISTORATOR_MODE.ALL.value)
        setSessionStorage(AdminLoginInfoSessionStorageKey.AUTHORITIES, JSON.stringify(authority))
        SessionStorageHelper.removeItem(AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD)
        SessionStorageHelper.removeItem(AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME)
    }

    static setSessionStorageForCondominiumMode(
        authority: string[] | null,
        condominiumCd: string | null,
        condominiumName: string | null,
    ): void {
        SessionStorageHelper.setItem(AdminLoginInfoSessionStorageKey.SELECTED_MODE,
            ADMINISTORATOR_MODE.CONDOMINIUM.value)
        setSessionStorage(AdminLoginInfoSessionStorageKey.AUTHORITIES, JSON.stringify(authority))
        setSessionStorage(AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD, condominiumCd)
        setSessionStorage(AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME, condominiumName)
    }

    static setSessionStorageForChangeBelongCondominiumGroup(
        belongCondominiumGroupId: number, belongCondominiumGroupName: string, authority: string[],
    ): void {
        SessionStorageHelper.setItem(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID,
            belongCondominiumGroupId,
        )
        SessionStorageHelper.setItem(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_NAME,
            belongCondominiumGroupName,
        )
        this.setSessionStorageForAllMode(authority)
    }
}
